import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  alerts: [],
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_HELPCENTER_ALERTS: {
      return Object.assign({}, state, { isLoading: true, alerts: [], error: false });
    }
    case types.RECEIVE_HELPCENTER_ALERTS: {
      return Object.assign({}, state, { isLoading: false, alerts: action.payload.alerts, error: false });
    }
    case types.RECEIVE_HELPCENTER_ALERTS_ERROR: {
      return Object.assign({}, state, { isLoading: false, alerts: [], error: true });
    }
    default:
      return state;
  }
}
